import { api } from '../config/api'

const educationalLevelsBaseURL = '/EducationalLevelApi'

export const getEducationalLevels = () => api.get(educationalLevelsBaseURL)

export const newGetEducationalLevels = () => api.get(`${educationalLevelsBaseURL}/GetAll`)
